module.exports = __webpack_public_path__ + "img/Fehlertyp5_Dok2.4311b058.jpg";